export const defaultElementsTypes = ['TAG', 'NEW-BLOCK', 'OFF-MAIN', 'TRACK'];
